module.exports = __webpack_public_path__ + "img/5k.d859fb27.png";